import * as moment from "moment-timezone";

export const TIMEZONES: { label: string; value: string }[] = moment.tz
  .names()
  .map((zone: string) => ({
    label: zone,
    value: zone,
  }));
